var millisecondsInDay = 86400000; // 1000 (ms in sec) * 60 (sec in min) * 60 (min in hr) * 24 (hr in day)
export function getDifferenceInDays(fromTimestamp) {
    var currentTime = Date.now();
    return (currentTime - fromTimestamp) / millisecondsInDay;
}
//# sourceMappingURL=getDifferenceInDays.js.map